import { render, staticRenderFns } from "./MonitoringErrorsSQL.vue?vue&type=template&id=abdb8cb0&scoped=true&lang=pug"
import script from "./MonitoringErrorsSQL.vue?vue&type=script&lang=js"
export * from "./MonitoringErrorsSQL.vue?vue&type=script&lang=js"
import style0 from "./MonitoringErrorsSQL.vue?vue&type=style&index=0&id=abdb8cb0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb8cb0",
  null
  
)

export default component.exports